import {Dict} from "../core/Reflection";
import {PostcardBeijing1Layout_main} from "../layout/PostcardBeijing1Layout";
import {PostcardBeijing2Layout_main} from "../layout/PostcardBeijing2Layout";
import {PostcardCusco1Layout_main} from "../layout/PostcardCusco1Layout";
import {PostcardCusco2Layout_main} from "../layout/PostcardCusco2Layout";
import {PostcardMunich1Layout_main} from "../layout/PostcardMunich1Layout";
import {PostcardMunich2Layout_main} from "../layout/PostcardMunich2Layout";
import {PostcardNairobi1Layout_main} from "../layout/PostcardNairobi1Layout";
import {PostcardNairobi2Layout_main} from "../layout/PostcardNairobi2Layout";
import {PostcardRio1Layout_main} from "../layout/PostcardRio1Layout";
import {PostcardRio2Layout_main} from "../layout/PostcardRio2Layout";
import {PostcardTokyo1Layout_main} from "../layout/PostcardTokyo1Layout";
import {PostcardTokyo2Layout_main} from "../layout/PostcardTokyo2Layout";
import {LevelNumber} from "./LevelModel";

export enum Location {
    Rio = "rio",
    Nairobi = "nairobi",
    Munich = "munich",
    Beijing = "beijing",
    Cusco = "cusco",
    Tokyo = "tokyo",
}

export const Locations: Location[] = [
    Location.Rio,
    Location.Nairobi,
    Location.Munich,
    Location.Beijing,
    Location.Cusco,
    Location.Tokyo,
];

export const LocationPostcardLayout: Dict<Location, Dict<LevelNumber, () => void>> = {
    [Location.Rio]: {
        1: PostcardRio1Layout_main,
        2: PostcardRio2Layout_main,
    },
    [Location.Nairobi]: {
        1: PostcardNairobi1Layout_main,
        2: PostcardNairobi2Layout_main,
    },
    [Location.Munich]: {
        1: PostcardMunich1Layout_main,
        2: PostcardMunich2Layout_main,
    },
    [Location.Beijing]: {
        1: PostcardBeijing1Layout_main,
        2: PostcardBeijing2Layout_main,
    },
    [Location.Cusco]: {
        1: PostcardCusco1Layout_main,
        2: PostcardCusco2Layout_main,
    },
    [Location.Tokyo]: {
        1: PostcardTokyo1Layout_main,
        2: PostcardTokyo2Layout_main,
    },
};
